import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const concludeSpawn = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	status: 'completed' | 'cancelled',
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('conclude_spawn', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyCompleteDerived')
		return null
	}
	try {
		const updated = await port.concludeSpawn(item.id, status, ctx.actorId, ctx.actorName)
		notify.success(status === 'completed' ? 'workItem.derivedCompleted' : 'workItem.derivedCancelled')
		return updated
	} catch {
		notify.error('workItem.concludeDerivedFailed')
		return null
	}
}

export { concludeSpawn }
